/*    
<summary>
  This functional component "ChangeThemeSettingsForm" handles the UI and logic for setting or updating the theme.
  Developer: Pratiksha Sharma, Created Date: 09-June-2025
</summary>
<returns>Returns JSX</returns>
*/

import { Field, Form, Formik } from "formik";
import React from "react";
import { Col, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import LoaderButton from "../../../../../shared-components/button/loader-button";
import { formatMessage } from "../../../../../translations/format-message";

interface IProps {
  initialValues: any;
}

const handleThemeChange = (theme: string) => {
  const body = document.body;
  body.className = "";
  localStorage.setItem("lizera_theme", theme);
  body.classList.add(`theme${theme || "0"}`);
  toast.success(formatMessage("theme_changed_successfully"));
};

const ChangeThemeSettingsForm = (props: IProps) => {
  return (
    <Formik
      initialValues={props.initialValues}
      enableReinitialize
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        resetForm();
        handleThemeChange(values.theme);
      }}
    >
      {({ values }) => (
        <Form className="setting-form" noValidate>
          <Row className="position-relative">
            <Col xs={12} md={12} className="form-group">
              <div className="position-relative swatch-wrapper">
                {Array.from({ length: 8 }, (_, i) => (
                  <React.Fragment key={i}>
                    <Field
                      type="radio"
                      name="theme"
                      value={i.toString()}
                      id={`theme${i}`}
                      className="swatch-input"
                      checked={values.theme === i.toString()}
                    />
                    <label
                      key={i}
                      className="swatch-label"
                      id={`themeLabel${i}`}
                      htmlFor={`theme${i}`}
                    >
                      {" "}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </Col>

            {/* Save Button */}
            <Col xs={12} md={12}>
              <LoaderButton
                type="button"
                variant="secondary"
                className="mt-3"
                text="button_save"
                isLoading={false}
                iconName="bi-check-lg"
                onClick={() => handleThemeChange(values.theme)}
              />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default ChangeThemeSettingsForm;
